/* eslint-disable import/named */
import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as types from '../constants';

import * as services from './service';
import * as Notification from './notification-saga';

const designReducer = state => state.get('designReducer');

export function* getListBlog(actions) {
  const response = yield call(services.getListBlogServer, actions.number);
  if (response) {
    yield put({
      type: types.GET_LIST_BLOG_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* getListNotificationSaga(data) {
  const response = yield call(Notification.getListNotificationService, data.shop);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* getNotificationDetailSaga(data) {
  const response = yield call(Notification.getNotificationDetailService, data.shop, data.id);
  if (response) {
    yield put({
      type: types.GET_NOTIFICATION_DETAIL_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* updateNotificationSaga(data) {
  const response = yield call(Notification.updateNotificationService, data.shop, data.id);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION,
      shop: data.shop
    });
  } else {
    console.log(response);
  }
}

function* getShopInfo({ shop_domain }) {
  const data = yield call(services.getShopInfoService, shop_domain);
  yield put({ type: types.GET_SHOP_INFO_RESPONSE, data });
}

function* getCurrencyShop() {
  try {
    const data = yield call(services.getCurrencyShopService);
    yield put({ type: types.GET_CURRENCY_SHOP_RESPONSE, data });
  } catch (error) {
    console.log(error);
  }
}

function* getGlobalSettingsShop() {
  const response = yield call(services.getDataSettingDesignService);
  if (response && response.global_extra_settings) {
    const data = JSON.parse(response.global_extra_settings);
    if (data.version === 2 || data.version === '2') {
      yield put({ type: types.GET_GLOBAL_SETTING_RESULT, res: data });
    }
    yield put({ type: types.GET_GLOBAL_SETTING_RESULT, res: false });
  } else {
    yield put({ type: types.GET_GLOBAL_SETTING_RESULT, res: false });
  }
}

function* saveSettingDesignSaga() {
  const data = yield select(designReducer);
  const response = yield call(services.saveSettingDesignService, data);
  yield put({ type: types.SAVE_SETTING_DESIGN_RESULT, res: response && response.success ? 1 : 2 });
}

function* getPricingPlanSaga() {
  const response = yield call(services.getPricingPlanService);
  yield put({
    type: types.GET_PRICING_PLAN_RESULT,
    res: response
  });
}

function* upgradePlanSaga(actions) {
  const response = yield call(services.upgradePlanService, actions);
  if (response && response.confirmation_url) {
    window.location.href = response.confirmation_url;
  } else {
    window.location.href = '';
  }
}

export function* getListCampaignAllSaga() {
  const response = yield call(services.getListUpsellCampaignService);
  yield put({
    type: types.GET_LIST_CAMPAIGN_ALL_RESULT,
    res: response
  });
}

function* changeStatusUpsellCampaignSaga(action) {
  const result = yield call(services.changeStatusCampaignUpsellService, action);
  yield put({
    type: types.CHANGE_STATUS_UPSELL_CAMPAIGN_RESULT,
    res: result && result.success,
    payload: action.payload
  });
}

function* deleteUpsellCampaignSaga(action) {
  const result = yield call(services.deleteCampaignUpsellV2Service, action);
  if (result && result.success) {
    yield getListCampaignAllSaga();
  }
  yield put({
    type: types.DELETE_UPSELL_CAMPAIGN_RESULT,
    res: result && result.success ? 1 : 2
  });
}

function* getCountViewSaga() {
  const result = yield call(services.getCountViewService);
  yield put({
    type: types.GET_COUNT_VIEW_RESULT,
    res: result
  });
}

function* getStatisticChartSaga(actions) {
  const result = yield call(services.getStatisticChartService, actions.payload);
  yield put({
    type: types.GET_STATISTIC_CHART_RESULT,
    res: result
  });
}

function* getViewByPlanSaga() {
  const result = yield call(services.getViewByPlanService);
  yield put({
    type: types.GET_VIEW_BY_PLAN_RESULT,
    res: result
  });
}

export function* changeAppStatusSaga(data) {
  const response = yield call(services.changeAppStatusService, data.status);
  if (response && response.success) {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      res: { result: 1, status: data.status }
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      res: { result: 2, status: !data.status }
    });
  }
}

function* sagaActions() {
  yield takeEvery(types.GET_LIST_BLOG, getListBlog);
  yield takeEvery(types.GET_LIST_NOTIFICATION, getListNotificationSaga);
  yield takeEvery(types.UPDATE_NOTIFICATION, updateNotificationSaga);
  yield takeEvery(types.GET_SHOP_INFO, getShopInfo);
  yield takeEvery(types.GET_CURRENCY_SHOP, getCurrencyShop);
  yield takeEvery(types.GET_GLOBAL_SETTING, getGlobalSettingsShop);
  yield takeEvery(types.SAVE_SETTING_DESIGN, saveSettingDesignSaga);
  yield takeEvery(types.GET_PRICING_PLAN, getPricingPlanSaga);
  yield takeEvery(types.UPGRADE_PLAN_PACKAGE, upgradePlanSaga);
  yield takeEvery(types.GET_LIST_CAMPAIGN_ALL, getListCampaignAllSaga);
  yield takeEvery(types.CHANGE_STATUS_UPSELL_CAMPAIGN, changeStatusUpsellCampaignSaga);
  yield takeEvery(types.DELETE_UPSELL_CAMPAIGN, deleteUpsellCampaignSaga);
  yield takeEvery(types.GET_COUNT_VIEW, getCountViewSaga);
  yield takeEvery(types.GET_STATISTIC_CHART, getStatisticChartSaga);
  yield takeEvery(types.GET_VIEW_BY_PLAN, getViewByPlanSaga);
  yield takeEvery(types.CHANGE_APP_STATUS, changeAppStatusSaga);
}

export default sagaActions;
